export class RDSnackBar {
  type = 'danger';
  title = '';
  text = '';
}
